export const VTMN_SEARCH_VARIANT = {
  DEFAULT: 'default',
  PERSISTENT: 'persistent',
  ON_CONTENT: 'on-content',
};

export const VTMN_SEARCH_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
};
